var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-margin-bottom-l"},[_c('button',{staticClass:"h-btn h-btn-accent",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v(" Save changes ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }